module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_m_erythristic.81bf9887.png";